import { View } from "binder"
import { LifeTime, LifeTimeManipulationViewModel } from "./lifeTimeManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class LifeTimeManipulationView extends View<LifeTimeManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-5C13AC99-8C7F-4232-BA42-7466F7A1AE41"
    }
    loadHtml(): string {
        let element = require('./lifeTimeManipulation.html').default;
        let style = require('./lifeTimeManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set lifeTimes(v: LifeTime) { this._lifeTimes = v; } public get lifeTimes(): LifeTime { return this._lifeTimes; } private _lifeTimes: LifeTime;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    downloadExcel() {
        this.dataContext.downloadExcel();
    }

    uploadExcel() {
        this.dataContext.uploadExcel();
    }
}
